import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@the-platform-group/component-library/Button'
import { AttachFile as AttachFileIcon } from '@the-platform-group/component-library/Icons'
import { ALL_EXTENSIONS } from 'constants/fileExtensions'

/**
 * Reusable button component for attaching files
 * @param {object} props - component props
 * @param {function} props.onFileSelect - function to handle file selection
 * @param {boolean} props.disabled - whether the button is disabled
 * @param {string} props.variant - button variant (default: "outlined")
 * @param {string} props.size - button size (default: "small")
 * @param {string} props.text - button text (default: "Attach Files")
 * @returns {React.ReactElement} The rendered AttachFilesButton component
 */
export default function AttachFilesButton({
  onFileSelect,
  disabled = false,
  variant = 'outlined',
  size = 'small',
  text = 'Attach Files',
}) {
  return (
    <Button
      variant={variant}
      component="label"
      size={size}
      startIcon={<AttachFileIcon />}
      disabled={disabled}
    >
      {text}
      <input
        multiple
        type="file"
        onChange={event => onFileSelect({ target: { files: [...event.target.files] } })}
        style={{ display: 'none' }}
        value=""
        accept={ALL_EXTENSIONS}
      />
    </Button>
  )
}

AttachFilesButton.propTypes = {
  onFileSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  size: PropTypes.string,
  text: PropTypes.string,
}
